import { dataFetcher, fileUploader } from 'core/services/requestHandler';   

const getLibraryBookings = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getLibraryBookings', data, {...config});
};

const getLibraryBookingsPendingRefund = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getLibraryBookingsPendingRefund', data, {...config});
};

const approveBookingRefund = async (data = {}, config = {}) => {
  return dataFetcher('bookings/approveBookingRefund', data, {...config});
};

const getLibraryBookingDetails = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getLibraryBookingDetails', data, {...config});
};


const bookingsBulkUpload = async (data = {}, config = {}) => {
  return fileUploader('bookings/upload', data, { method: 'POST', ...config});
};

export { 
  getLibraryBookings, approveBookingRefund, getLibraryBookingsPendingRefund, getLibraryBookingDetails, bookingsBulkUpload
};
